import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL — permanently redirects to keyword-first slug.
export const Route = createFileRoute("/woodland-park-web-design")({
  beforeLoad: () => {
    throw redirect({
      to: "/web-design-woodland-park-colorado",
      statusCode: 301,
    });
  },
});
